/*
 * This file is part of the https://gitlab-intern.easd-support.de/easd/p26s26_energie_watchdog project.
 *
 * (c) 2026 EA Systems Dresden GmbH
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

/* Import configuration */
import { refreshCsvSensorCatalog } from '@/config/csvSensors';
import { refreshDeviceSensorConfigs } from '@/config/deviceSensorConfig';
import { refreshEeCheckConfig } from '@/config/eeCheckConfig';
import { refreshSystemSectionConfigs } from '@/config/systemSections';

/** Rebuilds all user-scoped sensor configuration after login or logout. */
export function refreshSensorCatalog(username: string): void {
    refreshCsvSensorCatalog(username);
    refreshDeviceSensorConfigs();
    refreshEeCheckConfig();
    refreshSystemSectionConfigs();
}
